import * as React from "react";
const AccessoriesEcommContext = React.createContext(
  void 0
);
const MAX_ORDERABLE_QUANTITY = 5;
const AccessoriesEcommProvider = ({
  children,
  maxOrderableQuantity
}) => {
  const [quantity, setQuantityInternal] = React.useState(1);
  const setQuantity = React.useCallback((quantity2) => {
    setQuantityInternal(Math.max(1, quantity2));
  }, []);
  const value = React.useMemo(
    () => ({
      quantity,
      setQuantity,
      maxOrderableQuantity: maxOrderableQuantity ?? MAX_ORDERABLE_QUANTITY
    }),
    [maxOrderableQuantity, quantity, setQuantity]
  );
  return /* @__PURE__ */ React.createElement(AccessoriesEcommContext.Provider, { value }, children);
};
const useAccessoriesEcommContext = () => {
  const context = React.useContext(AccessoriesEcommContext);
  if (!context) {
    throw new Error("useAccessoriesEcommContext must be used within a AccessoriesEcommProvider");
  }
  return context;
};
export {
  AccessoriesEcommProvider,
  useAccessoriesEcommContext
};
//# sourceMappingURL=AccessoriesEcommContext.js.map
